import Heading, { HeadingProps } from './Heading';

export type H1Props = Omit<HeadingProps, 'as' | 'level'>;

/**
 * The largest heading: an `<h1>` at visual level 1, for a page's primary title.
 *
 * ## When to use
 *
 * - The single primary title of a page or view.
 *
 * ## When to choose another component
 *
 * - **Section / subsection headings** — use `H2`, `H3` or `H4`.
 * - **Tag and visual level must differ** — use `Heading`, e.g.
 *   `<Heading as="h1" level={2}>`.
 * - **Body copy, captions, labels** — use `Text`.
 *
 * ## Composition rules
 *
 * Fixed to `as="h1" level={1}`. It exposes no `as`, `level`, `className` or
 * `style`, so its typography and semantics cannot be overridden.
 */
const H1 = (props: H1Props) => <Heading as="h1" level={1} {...props} />;

export default H1;
